import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@material-ui/core';
import Container from '../../Common/Container';
import Grid from '../../Common/Grid';
import Header from '../../../containers/User/HeaderContainer';
import { AuthContext } from '../../../common/authContext';
import theme from '../../../common/theme';
import messages from './messages';

const adminItems = [
  { label: messages.reports, path: '/admin-panel/reports' },
  { label: messages.partners, path: '/admin-panel/partners' },
  { label: messages.realtors, path: '/admin-panel/realtors' }
];

export default function AdminPanel() {
  const history = useHistory();
  const { authUser } = useContext(AuthContext);

  if (!authUser?.isSuperAdmin) {
    history.push('/');
  }

  return (
    <>
      <Header />
      <Container
        maxWidth="md"
        component="div"
        disableGutters
        style={{ padding: theme.spacing(4) }}
      >
        <Grid container justifyContent="center">
          <Typography variant="h3">
            <FormattedMessage {...messages.adminPanel} />
          </Typography>

          <Box width="100%">
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <Typography variant="h6" style={{ fontWeight: 'bold' }}>
                        <FormattedMessage {...messages.options} />
                      </Typography>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {adminItems.map(item => (
                    <TableRow
                      key={item.path}
                      hover
                      onClick={() => history.push(item.path)}
                      style={{ cursor: 'pointer' }}
                    >
                      <TableCell>
                        <FormattedMessage {...item.label} />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Grid>
      </Container>
    </>
  );
}
